import { cx } from './cx'

/** Loading placeholder. The app already used animate-pulse for this. */
export default function Skeleton({ className }: { className?: string }) {
  return <div className={cx('animate-pulse bg-gray-200 rounded', className ?? 'h-4 w-full')} />
}
